/** A Blob's bytes: `Blob.arrayBuffer` where the browser has it, else a FileReader (older engines, jsdom). */
function bytesOf(blob: Blob): Promise<ArrayBuffer> {
  if (typeof blob.arrayBuffer === "function") return blob.arrayBuffer();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(blob);
  });
}

/**
 * ONE PDF made of several, every page of each in the order given — the printable copy of a set of
 * contracts (the prepared dialog's "הורדת PDF להדפסה"). Each part is used as it came: pages are
 * copied, never redrawn, so what prints is exactly what the server served for each contract.
 * pdf-lib is loaded on first use, so it stays out of the bundle until someone downloads a set.
 */
export async function mergePdfBlobs(parts: Blob[]): Promise<Blob> {
  const { PDFDocument } = await import("pdf-lib");
  const merged = await PDFDocument.create();
  for (const part of parts) {
    const source = await PDFDocument.load(await bytesOf(part));
    const pages = await merged.copyPages(source, source.getPageIndices());
    pages.forEach((page) => merged.addPage(page));
  }
  return new Blob([await merged.save()], { type: "application/pdf" });
}
